import React from 'react';

import { CarouselEventHud } from '@/components/event-hud/CarouselEventHud';
import { EventHudDetails } from '@/components/event-hud/EventHudDetails';
import { EventHudScoreboard } from '@/components/event-hud/EventHudScoreboard';
import { convertSbkEventToHudEvent } from '@/components/event-hud/utils';
import { Box } from '@/components/lib/components';
import { isStandaloneScoreboardSport } from '@/utils/sport-utils';

import { Event } from '../types';

type EventHudProps = {
    hudHeight: number;
    event: Event;
    showScoreboard?: boolean;
};

export const EventHud = ({ event, hudHeight, showScoreboard }: EventHudProps) => {
    const hudEvent = convertSbkEventToHudEvent(event);
    // Modern-variant sports (tennis) render the scoreboard alone. Classic-variant sports keep the
    // HUD-Live + Box-Score carousel.
    const showStandaloneScoreboard = showScoreboard && isStandaloneScoreboardSport(event.sport.name);
    return (
        <Box height={hudHeight}>
            {showStandaloneScoreboard ? (
                <EventHudScoreboard pamEventId={event.id} />
            ) : showScoreboard ? (
                <CarouselEventHud event={hudEvent} pamEventId={event.id} />
            ) : (
                <EventHudDetails event={hudEvent} pamEventId={event.id} />
            )}
        </Box>
    );
};
